import { useQuery } from "react-query";
import { useTokenQuery } from "./useTokenQuery";
import { useMsal, useAccount } from "@azure/msal-react";
import { fetchWithAuth } from "../components/helpers/fetchWithAuth";

export function useFixturesQuery() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const tokenQuery = useTokenQuery();

  return useQuery(
    "fixtures",
    async () => {
      let apiUrl = process.env.REACT_APP_API_URI.trim();
      const options = { method: "get" };

      // Use the fetchWithAuth helper to make the API call with token refresh handling
      return fetchWithAuth(
        `${apiUrl}/operator/fixtures`,
        options,
        instance,
        account,
        inProgress,
      );
    },
    {
      enabled: !!accounts.length && inProgress === "none" && !!tokenQuery.data,
      staleTime: 5 * 60 * 1000, // 5 minutes
      onError: (error) => {
        console.error("Error fetching fixtures:", error);
      },
    },
  );
}

// Returns a event object given an id
// replace this with an API call and set InitialData
// based on the parent fixtures call above
export function useFixture(id) {
  const fixturesQuery = useFixturesQuery();
  const event = fixturesQuery.data?.find((event) => event.id === id);

  return fixturesQuery.isLoading ? "Loading..." : event;
}
